export default __webpack_public_path__ + "9dba4e7edcab40aa8b309fcead8b69bc.jpg";